import React from "react";
import FooterIcon from "../Icons/FooterIcon";
import s from "./Footer.module.scss";
import Flogo from "./flogo.png"

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerStyle = {
    textAlign: 'center',
    backgroundColor: '#FFFFFF',
    color: 'black',
    padding: '10px',
    fontSize: '18px',
    alignItems: 'center', // Center vertically
    justifyContent: 'center', // Center horizontally
  };

  return (
    <footer style={footerStyle}>
        <img src={Flogo} alt="Logo" style={{ marginRight: '10px', width: '40px', height: '40px' }} />
      &copy; {currentYear} Smart Work Force Management
    </footer>
  );
}

export default Footer;

{/* <div className={s.footer}>
<span className={s.footerLabel}>2023 &copy; ABR SYSTEMS</span>
<FooterIcon />
</div> */}